module.exports = __webpack_public_path__ + "img/hb6.9438d5ac.jpg";